<div class="w-full rounded-xl border border-gray-100 bg-white shadow-sm">
  <h4 class="border-b border-gray-100 px-5 py-4 font-lato text-sm font-bold uppercase tracking-wide text-blue-950">
    Key Dates
  </h4>

  @if (upcoming) {
    <div class="border-b border-gray-100">
      <p class="px-5 pt-4 pb-2 font-lato text-xs font-semibold uppercase tracking-wide text-brand-muted">Upcoming</p>
      <div class="grid grid-cols-2 divide-x divide-y divide-gray-100">
        @for (i of upcoming; track $index) {
          <div class="bg-white px-5 py-4">
            <span class="flex items-center gap-1 font-lato text-xs font-semibold uppercase tracking-wide text-brand-muted">
              <mat-icon [inline]="true">{{ iconUpcoming }}</mat-icon>
              {{ i.title }}
            </span>
            <p class="mt-1 font-lato text-sm font-medium text-blue-950">{{ i.value || '—' }}</p>
          </div>
        }
      </div>
    </div>
  }

  @if (past) {
    <div>
      <p class="px-5 pt-4 pb-2 font-lato text-xs font-semibold uppercase tracking-wide text-brand-muted">Past</p>
      <div class="grid grid-cols-2 divide-x divide-y divide-gray-100">
        @for (i of past; track $index) {
          <div class="bg-white px-5 py-4">
            <span class="flex items-center gap-1 font-lato text-xs font-semibold uppercase tracking-wide text-green-600">
              <mat-icon [inline]="true">{{ iconPast }}</mat-icon>
              {{ i.title }}
            </span>
            <p class="mt-1 font-lato text-sm font-medium text-blue-950">{{ i.value | date: 'MM/dd/yyyy' }}</p>
          </div>
        }
      </div>
    </div>
  }
</div>
